import React from 'react';
import { UserModel } from '../models/user';

const UserContext = React.createContext({} as UserModel);
export const Consumer = UserContext.Consumer;

export default UserContext;